import { render, staticRenderFns } from "./charge-distribution-modal.vue?vue&type=template&id=926f904e&scoped=true&"
import script from "./charge-distribution-modal.vue?vue&type=script&lang=js&"
export * from "./charge-distribution-modal.vue?vue&type=script&lang=js&"
import style0 from "./charge-distribution-modal.vue?vue&type=style&index=0&id=926f904e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926f904e",
  null
  
)

export default component.exports